<template>
  <v-dialog
    v-model="localDialog"
    :fullscreen="$vuetify.breakpoint.mobile"
    :width="$vuetify.breakpoint.mobile ? '' : '800'"
    content-class="borderRadiusSearchGameDialog"
  >
    <v-card
      class="borderRadiusSearchGameDialog d-flex align-center flex-column"
      :ripple="false"
      outlined
    >
      <div
        class="d-flex align-center col-12 search-topbar px-0"
        style="position: sticky; top: 0;"
      >
        <v-btn plain class="col-1" @click="closeDialog" :ripple="false">
          <v-icon>
            {{ $vuetify.breakpoint.mobile ? "mdi-chevron-left" : "mdi-close" }}
          </v-icon>
        </v-btn>
        <v-text-field
          single-line
          class="game-search"
          :class="{
            'col-9 pr-0': $vuetify.breakpoint.mobile,
            'col-11 pr-4': !$vuetify.breakpoint.mobile,
          }"
          v-model="searchTerm"
          :label="$t('newCasino.search.inputLabel')"
          prepend-inner-icon="mdi-magnify"
          background-color="transparent"
          @focus="inputFocused = true"
          @blur="inputFocused = showLastSearches"
          :dense="$vuetify.breakpoint.smAndDown"
          filled
          hide-details
          clearable
          autofocus
        >
        </v-text-field>
      </div>

      <div
        v-if="showLastSearches"
        class="d-flex flex-column pt-5"
        style="width: 100%"
        :style="$vuetify.breakpoint.mobile ? '' : 'height: 60vh;'"
      >
        <div class="d-flex justify-space-between pb-3 px-4">
          <div style="font-size: 16px">
            {{ $t("newCasino.search.recentSearches") }}
          </div>

          <div
            style="font-size: 14px; color: #9D9D9D; cursor: pointer;"
            @click="removeAllSearches"
          >
            {{ $t("newCasino.search.removeAllSearches") }}
          </div>
        </div>

        <List
          :items="lastFifteenCasinoSearches"
          :filteredGamesLeft="[]"
          @openGameInformationDialog="openGameInformationDialog"
        />
      </div>

      <div
        v-if="noResults"
        class="d-flex flex-column text-center justify-center"
        :style="$vuetify.breakpoint.mobile ? 'height: 40vh' : 'height: 60vh'"
      >
        <v-icon size="60">
          mdi-message-question-outline
        </v-icon>

        <span class="text-h6 my-3">
          {{ $t("newCasino.search.gameNotFound") }}
        </span>

        <span>
          {{ $t("newCasino.search.verifySearchTerm") }}
        </span>
      </div>

      <div
        v-if="showCards"
        class="d-flex flex-column align-center justify-center"
        :style="$vuetify.breakpoint.mobile ? 'height: 75vh' : 'height: 60vh'"
      >
        <!-- <div style="position: absolute; z-index: 1;" class="d-none">
          <img src="./cards.svg" />
        </div>
        <div class="gradient d-none"></div> -->

        <v-icon size="60">
          {{ isCasinoType ? "mdi-slot-machine-outline" : "mdi-cards-club" }}
        </v-icon>

        <span class="text-h6 my-3">
          {{ $t("newCasino.search.noRecentSearches") }}
        </span>

        <span>
          {{ $t("newCasino.search.searchFavoritesGames") }}
        </span>
      </div>

      <List
        :items="showingFilteredGames"
        :filteredGamesLeft="filteredGamesLeft"
        @loadMore="loadMore"
        @openGameInformationDialog="openGameInformationDialog"
      />
    </v-card>

    <ItemDialog
      :dialog="gameDialog.status"
      :item="gameDialog.game"
      @closeItemDialog="closeGameDialog"
    />
  </v-dialog>
</template>

<script>
import ItemDialog from "../item/itemDialog.vue";
import List from "./list.vue";

export default {
  props: ["dialog", "games"],

  components: {
    ItemDialog,
    List,
  },

  data: () => ({
    localDialog: false,
    searchTerm: "",
    debouncedSearchTerm: "",
    gamesWithImageError: [],
    lastCasinoSearches: [],
    inputFocused: false,
    filteredGamesLeft: [],
    showingFilteredGames: [],
    gameDialog: {
      status: false,
      game: {},
    },
    timeout: 0,
  }),

  created() {
    this.localDialog = this.dialog;
    const lastCasinoSearches = localStorage.getItem(this.lastSearchesKey);
    this.lastCasinoSearches = lastCasinoSearches
      ? JSON.parse(lastCasinoSearches)
      : [];
  },

  watch: {
    searchTerm(val) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.debouncedSearchTerm = val;
      }, 300);
    },
    "$route.hash": {
      handler: function(dialog_id) {
        if (dialog_id !== "#search") {
          this.closeDialog();
          this.gameDialog = {
            status: false,
            game: {},
          };
        }
      },
      immediate: true,
    },
    lastCasinoSearches(val) {
      if (val.length === 0) {
        this.inputFocused = false;
      }
    },
    dialog(val) {
      if (this.localDialog !== val) {
        this.localDialog = val;
      }

      if (val) {
        const lastCasinoSearches = localStorage.getItem(this.lastSearchesKey);
        this.lastCasinoSearches = lastCasinoSearches
          ? JSON.parse(lastCasinoSearches)
          : [];
      }
    },
    localDialog(val) {
      if (!val) {
        if (this.$route.hash === "#search") {
          this.$router.go(-1);
        }

        this.closeDialog();
      }
    },
    filteredGames(val) {
      this.filteredGamesLeft = val;
      this.showingFilteredGames = this.filteredGamesLeft.splice(0, 30);
    },
  },

  computed: {
    filteredGames() {
      if (!this.debouncedSearchTerm) {
        return [];
      }

      return this.uniqueGames.filter((game) =>
        game.title_game
          .toLowerCase()
          .includes(this.debouncedSearchTerm.toLowerCase())
      );
    },
    uniqueGames() {
      if (!this.games) {
        return [];
      }

      const unique = [];

      this.games.forEach((game) => {
        if (!unique.find(({ game_id }) => game_id === game.game_id)) {
          unique.push({
            ...game,
            avatar: encodeURI(
              `https://cdn.softswiss.net/i/s3/${game.provider_id}/${
                game.identifier.split(":")[1]
              }.png`.replace(/\s/g, "")
            ),
          });
        }
      });

      return unique;
    },
    showLastSearches() {
      return (
        this.lastCasinoSearches.length > 0 &&
        !this.debouncedSearchTerm &&
        this.inputFocused
      );
    },
    showCards() {
      if (!this.$vuetify.breakpoint.mobile) {
        if (this.lastCasinoSearches.length === 0) {
          return !this.debouncedSearchTerm;
        }
      }

      return !this.noResults && !this.searchTerm && !this.inputFocused;
    },
    noResults() {
      return this.debouncedSearchTerm && this.showingFilteredGames.length === 0;
    },
    lastSearchesKey() {
      return `${this.$route.params.casinoType}LastSearches`;
    },
    lastFifteenCasinoSearches() {
      return this.lastCasinoSearches.slice(0, 15);
    },
    isCasinoType() {
      return this.$route.params.casinoType === "casino";
    },
  },

  methods: {
    openGameInformationDialog(game) {
      const lastCasinoSearches = localStorage.getItem(this.lastSearchesKey);
      let updatedCasinoSearches = [];

      if (lastCasinoSearches) {
        let parsed = JSON.parse(lastCasinoSearches);

        parsed = parsed.filter(
          ({ title_game }) => title_game !== game.title_game
        );

        const newCasinoSearches = [game, ...parsed];

        updatedCasinoSearches = newCasinoSearches.slice(0, 15);
      } else {
        updatedCasinoSearches = [game];
      }

      localStorage.setItem(
        this.lastSearchesKey,
        JSON.stringify(updatedCasinoSearches)
      );

      this.lastCasinoSearches = updatedCasinoSearches;

      this.gameDialog = {
        status: true,
        game,
      };
    },
    closeDialog() {
      this.$emit("closeDialog");

      setTimeout(() => {
        this.inputFocused = false;
        this.searchTerm = "";
        this.gamesWithImageError = [];
      }, 100);
    },
    loadMore() {
      this.showingFilteredGames = [
        ...this.showingFilteredGames,
        ...this.filteredGamesLeft.splice(0, 30),
      ];
    },
    setSearch(term) {
      this.searchTerm = term;
    },
    removeSearch(term) {
      const strSearches = localStorage.getItem(this.lastSearchesKey);
      const arrSearches = JSON.parse(strSearches);
      const newSearches = arrSearches.filter((search) => search !== term);
      localStorage.setItem(this.lastSearchesKey, JSON.stringify(newSearches));
      this.lastCasinoSearches = newSearches;
    },
    removeAllSearches() {
      localStorage.setItem(this.lastSearchesKey, JSON.stringify([]));
      this.lastCasinoSearches = [];
    },
    closeGameDialog() {
      this.gameDialog.status = false;
    },
  },
};
</script>

<style>
.borderRadiusSearchGameDialog {
  border-radius: 27px !important;
}

.game-search .v-input__slot {
  padding: 0 !important;
}

.gradient {
  position: relative;
  width: 250px;
  height: 250px;
  background: radial-gradient(
    circle,
    var(--v-primary-base) 0%,
    var(--v-colorDominant-base) 100%
  );
  filter: blur(100px);
  z-index: 0;
}

.search-topbar {
  position: sticky;
  z-index: 2;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(12.5px);
}
</style>
